module.exports = __webpack_public_path__ + "static/media/placeholder.902e9dd4.svg";